/**
 * Cover letter templates in HTML format
 * Each template function takes coverLetterData and returns HTML
 */

import standardTemplateHtml from "./standardTemplateHtml";
import professionalTemplateHtml from "./professionalTemplateHtml";
import creativeTemplateHtml from "./creativeTemplateHtml";
import minimalTemplateHtml from "./minimalTemplateHtml";

// Export all templates
export const templates = {
  standard: {
    name: "Standard",
    description: "Traditional cover letter format",
    generator: standardTemplateHtml,
  },
  professional: {
    name: "Professional",
    description: "Polished design for corporate applications",
    generator: professionalTemplateHtml,
  },
  creative: {
    name: "Creative",
    description: "Modern design with personality",
    generator: creativeTemplateHtml,
  },
  minimal: {
    name: "Minimal",
    description: "Clean, simple design",
    generator: minimalTemplateHtml,
  },
};

// Function to get all templates
export const getTemplates = () => {
  return Object.entries(templates).map(([id, template]) => ({
    id,
    name: template.name,
    description: template.description,
    generator: template.generator, // Include the generator function
  }));
};

// Export individual templates
export {
  standardTemplateHtml,
  professionalTemplateHtml,
  creativeTemplateHtml,
  minimalTemplateHtml,
};

export default templates;
